import React from "react";

import styled from "styled-components";

import ManuscriptHistoryPanel from "components/organisms/manuscript/history/ManuscriptHistoryPanel";
import ManuscriptPdfPanel from "components/organisms/manuscript/pdf/ManuscriptPdfPanel";
import ManuscriptReviewPanel from "components/organisms/manuscript/review/ManuscriptReviewPanel";

const Panel = styled.section`
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 0;
    height: 100%;
    overflow: hidden;
    background: #f7fafc;

    @media (max-width: 1100px) {
        display: ${(props) => (props.$collapsed ? "none" : "flex")};
        position: fixed;
        top: 40px;
        right: 40px;
        bottom: 0;
        z-index: 70;
        width: min(460px, calc(100vw - 80px));
        border-left: 1px solid #c9d6e3;
        box-shadow: -16px 0 34px rgba(15, 23, 42, 0.16);
    }
`;

const Shell = styled.div`
    display: ${(props) => (props.$collapsed ? "none" : "flex")};
    flex-direction: column;
    min-width: 0;
    min-height: 0;
    width: 100%;
    height: 100%;
`;

function ManuscriptRightPanel({
    activePanel,
    latestCompile,
    pdfArtifact,
    pdfRevisionSeq,
    logArtifact,
    compileRevisionSeq,
    compileLogRaw,
    compileLogEntries,
    compileLogLoading,
    compileLogLoadError,
    onCompile,
    onLogEntrySelect,
    compileLoading,
    compileDisabled,
    compileHasLintError,
    compileDisabledReason,
    historyItems,
    restoreMutation,
    handleRestoreRevision,
    saveLabel,
    reviewThreads,
    selectedReviewThreadId,
    onSelectReviewThread,
    onReviewThreadMount,
    isCollapsed,
}) {
    return (
        <Panel $collapsed={isCollapsed}>
            <Shell $collapsed={isCollapsed}>
                {activePanel === "pdf" ? (
                    <ManuscriptPdfPanel
                        latestCompile={latestCompile}
                        pdfArtifact={pdfArtifact}
                        pdfRevisionSeq={pdfRevisionSeq}
                        logArtifact={logArtifact}
                        compileRevisionSeq={compileRevisionSeq}
                        compileLogRaw={compileLogRaw}
                        compileLogEntries={compileLogEntries}
                        compileLogLoading={compileLogLoading}
                        compileLogLoadError={compileLogLoadError}
                        onCompile={onCompile}
                        onLogEntrySelect={onLogEntrySelect}
                        compileLoading={compileLoading}
                        compileDisabled={compileDisabled}
                        compileHasLintError={compileHasLintError}
                        compileDisabledReason={compileDisabledReason}
                    />
                ) : null}

                {activePanel === "history" ? (
                    <ManuscriptHistoryPanel
                        historyItems={historyItems}
                        restoreMutation={restoreMutation}
                        handleRestoreRevision={handleRestoreRevision}
                        saveLabel={saveLabel}
                    />
                ) : null}

                {activePanel === "review" ? (
                    <ManuscriptReviewPanel
                        reviewThreads={reviewThreads}
                        selectedReviewThreadId={selectedReviewThreadId}
                        onSelectReviewThread={onSelectReviewThread}
                        onReviewThreadMount={onReviewThreadMount}
                    />
                ) : null}
            </Shell>
        </Panel>
    );
}

export default ManuscriptRightPanel;
